import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export interface IDocument {
    document_ID?: number;
    document_Name: string;
}

interface IProps {
    setModal: (modal: { open: boolean; singleData: IDocument }) => void;
    reload: boolean;
    toast: any;
}

const EmptyDocument: IDocument = {
    document_Name: "",
};

export const Table = ({ reload, setModal }: IProps) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<IDocument[]>([]);
    const openNew = () => {
        setModal({ open: true, singleData: EmptyDocument });
    };

    const leftToolbarTemplate = () => (
        <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
    );

    const loadTableData = async () => {
        setLoading(true);
        const response = await Fetch("ApwDocument_Mast/getDocumnent", "GET", null, null, null);
        if (response) {
            const result = await response.json();
            setData(result || []);
        }
        setLoading(false);
    };

    useEffect(() => {
        loadTableData();
    }, [reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} />
            <DataTable value={data} size="small" emptyMessage="No Data found." className="p-datatable-sm" loading={loading}
            >
                <Column header="S.No" body={(_, opt) => opt.rowIndex + 1} />
                <Column field="document_Name" header="Document Name" />
                <Column header="Action"
                    body={(rowData: IDocument) => (
                        <i className="pi pi-pencil text-primary" style={{ cursor: "pointer" }} onClick={() => setModal({ open: true, singleData: rowData })} />
                    )}
                />
            </DataTable>
        </>
    );
};
